module.exports = []


//////////////////
// WEBPACK FOOTER
// ./.cache/redirects.json
// module id = 1483
// module chunks = 231608221292675